
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"44","height":"44"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 6303","fill":"none"}},[_c('path',{attrs:{"data-name":"Rectangle 4207","d":"M0 0h44v44H0z"}}),_c('g',{attrs:{"data-name":"Group 5951","stroke":"#109a50","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"data-name":"Path 7795","d":"M8.883 35.92l1.9-7.169a2.1 2.1 0 011.411-1.651l3.869-1.291a2.11 2.11 0 012.165.518l4.341 4.4 4.341-4.4a2.11 2.11 0 012.165-.518l3.869 1.291a2.1 2.1 0 011.411 1.651l1.9 7.169z"}}),_c('path',{attrs:{"data-name":"Path 7796","d":"M27.827 13.991a5.268 5.268 0 10-10.524 0v1.578a5.268 5.268 0 1010.524 0z"}})])])])
          )
        }
      }
    